import React, { useState, useContext, useEffect } from 'react';
import { BrandContext } from '../../contexts/brand-context';
import SpinnerLoader from '../layout/spinner-loader';
import { UserContext } from '../../contexts/user-context';
import { useForm } from "react-hook-form";
import { FilePath } from '../../services/utilities';
import apiPreferredCustomer from '../../services/api-preferred-customer';
import '../preferred-customer/profile.scss';

const AddYourLogo = ({toolName, setIncludeLogo}) => {
    const { selectedBrand } = useContext(BrandContext);
    const { pcUser,  getUserProfileSilently } = useContext(UserContext);
    const [uploading, setUploading] = useState(false);
    const { register, handleSubmit, watch, setValue } = useForm();
    const watchInclude = watch("includeLogo");

    useEffect(() => {
        setIncludeLogo(watchInclude);
    }, [watchInclude]);

    const onAddLogoSubmit = data => {
        setUploading(true);
        if (!data.logo) return;
        data.selectedBrand = selectedBrand;
        data.preferredCustomerId = pcUser.preferredCustomerId;
        if (data.logo[0] && !pcUser.logo?.includes(data.logo[0].name)) {
            const uploadLogo = async () => {
                await apiPreferredCustomer.post(`/upload-logo?preferredCustomerId=` + pcUser.preferredCustomerId, data.logo);
            }
            uploadLogo();
        }
        data.logo = data.logo && data.logo[0] ? data.logo[0].name : pcUser.logo;
        const submitProfileUpdate = async () => {
            await apiPreferredCustomer.post(`/change-logo-on-account/${data.logo}`).then(() => { setUploading(false); getUserProfileSilently() });
        }
        submitProfileUpdate();
    }

    const removeLogo = () => {
        setUploading(true);
        const remove = async () => {
            await apiPreferredCustomer.post(`/remove-logo?preferredCustomerId=` + pcUser.preferredCustomerId).then((response) => { 
                setUploading(false);
                getUserProfileSilently();
            });
        }
        remove();
        setValue('logo', null);
    }
    
              
    return (
        <>
           <div className="modal" id="addLogoModal" tabIndex="-1" aria-labelledby="addLogoModalLabel" aria-hidden="true" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addLogoModalLabel">Add Your Logo</h5>
                        </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onAddLogoSubmit)}>
                        {!uploading && <div className="row">
                            <div className="col-6 mt-2">
                                <label className="fw-bold">Add your logo to this {toolName} when downloading and emailing?:</label>
                            </div>
                            <div className="col-6 mt-2">
                                <label htmlFor="includeLogo"><input type="checkbox" id="includeLogo" {...register("includeLogo")} /> Yes</label>
                            </div>
                            <div className="col-6 mt-2">
                                <label className="fw-bold" htmlFor="logo">Selected Logo:</label>
                                <br/><small>Current logo is displayed, upload a new logo using the "Choose File" button.</small>
                            </div>
                            <div className="col-6 mt-2">
                                {pcUser.logo && <input name="removeLogo" type="button" value="Remove Logo" className="btn btn-primary" id="removeLogo" onClick={() => removeLogo()}/>}
                                <input name="logo" type="file" id="logo" className="pt-2" {...register("logo")} />
                                {pcUser.logo ? <img className="pt-2 pc-logo" alt="Preferred Customer Logo" src={FilePath('/preferredcustomerlogos/' + pcUser.logo)} /> : <span><br/>No logo uploaded.</span> }
                            </div>
                        </div>
                        }
                        {uploading && <SpinnerLoader />}
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-primary m-auto" disabled={uploading}>Upload New Logo</button>
                            <button type="button" className="btn btn-primary m-auto" data-bs-dismiss="modal">Close</button>
                        </div>
                    </form>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

export default AddYourLogo;